import React, { useState, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AuthGuard from '../interceptors/AuthGuard';
import SidebarLayout from '../layouts/SidebarLayout';
import LoginPage from '../features/auth/pages/LoginPage';
import DashboardPage from '../pages/DashboardPage';
import AboutPage from '../pages/AboutPage';
import AddUserPage from '../pages/User/AddUserPage';
import RolesAndPermission from '../pages/RolesAndPermission';
import ForgotPasswordPage from '../features/auth/pages/ForgotPasswordPage';
import NewPassword from '../features/auth/pages/NewPassword';
import SitesPage from '../pages/Sites/SitesPage';
import Regions from '../pages/Regions';
import RApplicationComponent from '../pages/R application/RApplicationComponent';
import ControlBar from '../pages/R application/ControlBar';
import downloadIcon from '../assets/Icon/download_icon.svg';
import CompanyPage from '../pages/Company/CompanyPage';
import SystemConfig from '../pages/SystemConfig/SystemConfig';
import PricingCurvePage from '../pages/PricingCurvePage';
import ImpactAnalysisPage from '../pages/ImpactAnalysisPage';
import ValidAnalysisPage from '../pages/ValidAnalysisPage';
import RevenueComponent from '../pages/Revenue/RevenueComponent';
import DemandReport from '../pages/DemandReport';
import PriceComparativePage from '../pages/PriceComparativePage';
import { MoveToPriceLineContext, SelectionContext } from '../pages/R application/ControlBar';
import MainTab from '../pages/R application/MainTab';
import PartDetailTab from '../pages/R application/PartDetailTab';
import SalesDetailTab from '../pages/R application/SalesDetailTab';
import AllInterchangesTab from '../pages/R application/AllInterchangesTab';
import InventoryAlertsTab from '../pages/R application/InventoryAlertsTab';
import PriceLineConfigTab from '../pages/R application/PriceLineConfigTab';
import BatchExportQueueTab from '../pages/R application/BatchExportQueueTab';
import { PermissionGuard } from '../components/PermissionGuard';
import { PERMISSION_CODES } from '../utils/permissionUtils';
import NewCom from '../pages/BatchPricingOverride'
import BatchPricingPage from '../pages/BatchPricingPage';
import GlobalConfigurationPage from '../pages/GlobalConfiguration/GlobalConfigurationPage';
import AllInterchanges from '../pages/AllInterchanges/AllInterchnages';


const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<LoginPage />} />
        
        {/* Protected Routes with Sidebar Layout */}
        <Route
          path="/"
          element={
            <AuthGuard>
              <SidebarLayout />
            </AuthGuard>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="add-user" element={<AddUserPage />} />
          <Route path="roles-and-permissions" element={<RolesAndPermission />} />
          <Route path="sites" element={<SitesPage />} />
          <Route path="regions" element={<Regions />} />
          <Route path="r-application" element={<RApplicationComponent />} />
          <Route path="control-bar" element={<ControlBar />}>
          <Route path="main" element={<MainTab />} />
          <Route path="part-detail" element={<PartDetailTab />} />
            <Route path="sales-detail" element={<SalesDetailTab />} />
            <Route path="all-interchanges" element={<AllInterchangesTab />} />
            <Route path="inventory-alerts" element={<InventoryAlertsTab />} />
            <Route path="price-line-config" element={<PriceLineConfigTab />} />
            <Route path="batch-export-queue" element={<BatchExportQueueTab />} />
          </Route>
          <Route path="company" element={<CompanyPage />} />
          <Route path="system-config" element={<SystemConfig />} />
          <Route path="pricing-curve" element={<PricingCurvePage />} />
          <Route path="batchpricingoverride" element={<NewCom/>} />
          <Route path="batch-pricing" element={<BatchPricingPage />} />
          <Route path="interchnages" element={<AllInterchanges/>} />
          <Route path="impact-analysis" element={
            <PermissionGuard permission={PERMISSION_CODES.IMPACT_ANALYSIS}>
              <ImpactAnalysisPage />
            </PermissionGuard>
          } />
          <Route path="valid-analysis" element={
            <PermissionGuard permission={PERMISSION_CODES.Sufficiency_ANALYSIS}>
              <ValidAnalysisPage />
            </PermissionGuard>
          } />
          <Route path="revenue" element={
            <PermissionGuard permission={PERMISSION_CODES.REVENUE_REPORT}>
              <RevenueComponent />
            </PermissionGuard>
          } />
          <Route path="demand-report" element={
            <PermissionGuard permission={PERMISSION_CODES.DEMAND_REPORT}>
              <DemandReport />
            </PermissionGuard>
          } />
          <Route path="price-comparative" element={<PriceComparativePage />} />
          <Route path="global-configuration" element={<GlobalConfigurationPage />} />
        </Route>

        {/* Catch all route - redirect to login for unauthenticated users */}
        <Route path="*" element={<Navigate to="/login" replace />} />

        <Route path="forgot-password" element={<ForgotPasswordPage />} />
        <Route path="reset-password" element={<NewPassword />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes; 